import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export const Button = ({
  children,
  className = '',
  href,
  onClick
}: ButtonProps) => {
  const baseClasses = `inline-block bg-brand-green hover:bg-green-500 text-darker font-bold py-4 px-8 rounded-full text-lg shadow-[0_0_20px_rgba(74,222,128,0.3)] hover:shadow-[0_0_30px_rgba(74,222,128,0.5)] transition-all duration-300 transform hover:-translate-y-1 text-center no-underline cursor-pointer ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={baseClasses} data-id="element-27">
        {children}
      </a>;
  }
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    const el = document.getElementById('comprar');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button className={baseClasses} onClick={handleClick} data-id="element-28">
      {children}
    </button>;
};